import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import { Button, Card, Col, Form, Row, Spinner, Table, Badge, Pagination } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import Select from 'react-select';

const JourneyCouponReport = () => {

    const accessToken = localStorage.getItem("accessToken");
    const [skin, setSkin] = useState(localStorage.getItem("skin-mode") || "light");
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedOutlet, setSelectedOutlet] = useState("");
    const [selectedOutletName, setSelectedOutletName] = useState("");
    const [outlets, setOutlets] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [clicked, setClicked] = useState(false);
    const navigate = useNavigate();
    const [subBtnLoading, setSubBtnLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    // const outletOptions = outlets.map((outlet) => ({
    //     value: outlet._id,
    //     label: `${outlet.name} (${outlet.city})`,
    // }));

    const outletOptions = [
        { value: "", label: "All Outlets" },
        ...outlets?.map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }))
    ]

    const getOutlets = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE" || "INACTIVE");
                setOutlets(filteredOutlets);
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }

        getCouponUsage(selectedOutlet, startDate, endDate, page, recordsPerPage);
    };



    const getCouponUsage = async (outlet, sDate, eDate, page, limit) => {
        if ( !startDate) {
            toast.error("Please select both start and end date.");
            return;
        }

        setSubBtnLoading(true);
        setClicked(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            }

            let apiUrl =  `/auto-coupon-allocation/getAutoCouponUsageReport?startDate=${sDate.toISOString().split("T")[0]}&endDate=${eDate.toISOString().split("T")[0]}&page=${page}&limit=${limit}`;

            if(outlet) {
                apiUrl += `&outlet=${outlet}`;
            }

            // Using the correct API endpoint with query parameters
            const response = await axios.get(apiUrl, { headers });
            // const response = await axios.get(`/auto-coupon-allocation/getAutoCouponUsageSummary?outlet=${outlet}&date=${date.toISOString().split("T")[0]}&endDate=${date.toISOString().split("T")[0]}`, { headers });

            console.log("Response of journey coupon report :", response);
            setTotalPages(response?.data?.pagination?.totalPages || 1);
            setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            // Handle different response structures
            if (response?.data?.data) {
                setReportData(response.data.data);
                toast.success("Report generated successfully!");
            } else if (response?.data && Array.isArray(response.data)) {
                setReportData(response.data);
                toast.success("Report generated successfully!");
            } else {
                setReportData([]);
                toast.info("No data found for the selected criteria.");
            }

        } catch (error) {
            console.log("Error in Fetching journey coupon report :", error);
            handleApiError(error);
            setReportData([]);
        } finally {
            setSubBtnLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }

        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setClicked(true);
        getCouponUsage(selectedOutlet, startDate, endDate, 1, recordsPerPage);
    }

    const handleRefresh = async () => {
        if (selectedOutlet && startDate) {
            getCouponUsage(selectedOutlet, startDate, endDate, 1, recordsPerPage);
        } else {
            toast.error("Please select both outlet and start date to refresh.");
        }
    }

    // Calculate totals for summary
    const calculateTotals = () => {
        const totalAllocated = reportData.reduce((sum, item) => sum + (item.allocatedUsers || 0), 0);
        const totalUsed = reportData.reduce((sum, item) => sum + (item.usedUsers || 0), 0);
        const totalUnused = reportData.reduce((sum, item) => sum + (item.allocatedUsers - item.usedUsers || 0), 0);

        return { totalAllocated, totalUsed, totalUnused };
    };

    const renderPaginationItems = () => {
        if (totalPages > 15) {
            return (
                <>
                    {currentPage > 3 && (
                        <Pagination.Item onClick={() => handlePageChange(1)}>
                            1
                        </Pagination.Item>
                    )}
                    {currentPage > 4 && <Pagination.Ellipsis />}

                    {Array.from({ length: 5 }, (_, i) => {
                        const pageNumber = currentPage > 3 ? currentPage - 2 + i : i + 1;
                        if (pageNumber <= totalPages) {
                            return (
                                <Pagination.Item
                                    key={pageNumber}
                                    active={pageNumber === currentPage}
                                    onClick={() => handlePageChange(pageNumber)}
                                >
                                    {pageNumber}
                                </Pagination.Item>
                            );
                        }
                        return null;
                    })}

                    {currentPage < totalPages - 3 && <Pagination.Ellipsis />}
                    {currentPage < totalPages - 2 && (
                        <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                            {totalPages}
                        </Pagination.Item>
                    )}
                </>
            );
        } else {
            return Array.from({ length: totalPages }, (_, i) => (
                <Pagination.Item
                    key={i + 1}
                    active={i + 1 === currentPage}
                    onClick={() => handlePageChange(i + 1)}
                >
                    {i + 1}
                </Pagination.Item>
            ));
        }
    };

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
    }, []);

    useEffect(() => {
        getOutlets();
    }, []);

    useEffect(() => {
        console.log("hello");
        if(clicked) {
          getCouponUsage(
            selectedOutlet, startDate, endDate, 1, recordsPerPage
          );
        }
    
      }, [recordsPerPage]);

    const { totalAllocated, totalUsed, totalUnused } = calculateTotals();

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-white border-0">
                        <div className="card-header bg-white border-0 py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h4 className="mb-0 fw-bold d-inline-block">
                                    <i className="bi bi-ticket-perforated me-2"></i>JOURNEY COUPON USAGE REPORT
                                </h4>
                            </div>
                            <div>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => navigate('/reports/all-reports')}
                                    className="me-3 d-flex align-items-center fw-semibold"
                                    style={{ height: '38px' }}
                                >
                                    <ArrowLeft className="me-1" /> Back to Reports
                                </Button>
                            </div>
                        </div>
                    </Card.Header>
                    <hr className='mt-0 mb-0' />

                    <Card.Body>
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3 mb-4">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={4} lg={4} sm={3}>
                                        <Form.Group controlId="outletSelect">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-shop me-2"></i>Outlet
                                            </Form.Label>
                                            <Select
                                                options={outletOptions}
                                                value={outletOptions.find(option => option.value === selectedOutlet)}
                                                onChange={(selectedOption) => {
                                                    const selectOutlet = selectedOption?.value;
                                                    setSelectedOutlet(selectOutlet);
                                                    setSelectedOutletName(selectedOption?.label)
                                                }}
                                                isClearable
                                                styles={customStyles}
                                                placeholder="Select Outlet"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} lg={2} sm={3}>
                                        <Form.Group controlId="startDate">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-calendar me-2"></i>Start Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select Date"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} lg={2} sm={3}>
                                        <Form.Group controlId="endDate">
                                            <Form.Label className="fw-semibold">
                                                <i className="bi bi-calendar me-2"></i>End Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Select Date"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>


                                    <Col md={2} lg={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            className="w-100 py-2"
                                            type="submit"
                                            disabled={subBtnLoading || !startDate}
                                        >
                                            {subBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>

                                    <Col md={2} lg={2} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-primary"
                                            className="w-100"
                                            onClick={handleRefresh}
                                            disabled={!startDate || subBtnLoading}
                                        >
                                            {subBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Refresh"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {/* Report Table Section */}
                        {clicked && (
                            <>
                                {reportData && reportData.length > 0 ? (
                                    <>
                                        {/* Summary Cards */}
                                        <Row className="mb-4">
                                            <Col md={4}>
                                                <Card className="bg-primary text-white shadow-sm">
                                                    <Card.Body className="py-3">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-0">Total Allocated</h6>
                                                                <h3 className="mb-0 fw-bold">{totalAllocated}</h3>
                                                            </div>
                                                            <i className="bi bi-people fs-1 opacity-50"></i>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4}>
                                                <Card className="bg-success text-white shadow-sm">
                                                    <Card.Body className="py-3">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-0">Total Used</h6>
                                                                <h3 className="mb-0 fw-bold">{totalUsed}</h3>
                                                            </div>
                                                            <i className="bi bi-check-circle fs-1 opacity-50"></i>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={4}>
                                                <Card className="bg-warning text-white shadow-sm">
                                                    <Card.Body className="py-3">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-0">Total Unused</h6>
                                                                <h3 className="mb-0 fw-bold">{totalUnused}</h3>
                                                            </div>
                                                            <i className="bi bi-clock-history fs-1 opacity-50"></i>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>

                                        {/* Pagination Controls - Top */}
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex align-items-center">
                                                <span className="me-2 text-muted">Show</span>
                                                <Form.Select
                                                    style={{ width: "auto" }}
                                                    value={recordsPerPage}
                                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                                    className="border-secondary"
                                                >
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                    <option value={200}>200</option>
                                                </Form.Select>
                                                <span className="ms-2 text-muted">entries</span>
                                            </div>
                                            <Pagination className="mb-0">
                                                <Pagination.Prev
                                                    disabled={currentPage === 1}
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                />
                                                {renderPaginationItems()}
                                                <Pagination.Next
                                                    disabled={currentPage === totalPages}
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                />
                                            </Pagination>
                                        </div>

                                        {/* Table */}
                                        <div className="table-responsive">
                                            <Table striped bordered hover className="align-middle">
                                                <thead className="bg-light">
                                                    <tr> 
                                                        <th className="text-center" style={{ width: '60px' }}>#</th>
                                                        <th>Coupon Title</th>
                                                        <th>On Orders</th>
                                                        <th>Status</th>
                                                        <th className="text-center">Total Allocated</th>
                                                        <th className="text-center">Total Used</th>
                                                        <th className="text-center">Total Unused</th>
                                                        <th className="text-center">Usage Rate</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reportData.map((item, index) => {
                                                        const usageRate = item.allocatedUsers > 0
                                                            ? ((item.usedUsers / item.allocatedUsers) * 100).toFixed(2)
                                                            : '0.00';

                                                        return (
                                                            <tr key={item.autoCouponAllocationId || index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td className="fw-semibold text-muted">{item.title || 'N/A'}</td>
                                                                <td className="text-center text-muted fw-semibold">{item.nthOrderNumber || 0} th</td>
                                                                <td className={`text-center fw-semibold ${item.status === 'ACTIVE' ? 'text-success' : 'text-secondary'}`}>
                                                                    {/* <Badge bg={item.status === 'ACTIVE' ? 'success' : 'secondary'}> */}
                                                                        {item.status || 'N/A'}
                                                                    {/* </Badge> */}
                                                                </td>
                                                                <td className="text-center fw-bold text-muted">{item.allocatedUsers || 0}</td>
                                                                <td className="text-center text-success fw-bold">{item.usedUsers || 0}</td>
                                                                <td className="text-center text-warning fw-bold">{item.allocatedUsers - item.usedUsers || 0}</td>
                                                                <td className="text-center">
                                                                    <Badge bg={usageRate >= 0.0001 ? 'success' : 'danger'}>
                                                                        {usageRate}%
                                                                    </Badge>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    {/* Summary Row */}
                                                    <tr className="fw-bold">
                                                        <td colSpan="4" className="text-end">TOTAL:</td>
                                                        <td className="text-center">{totalAllocated}</td>
                                                        <td className="text-center text-success">{totalUsed}</td>
                                                        <td className="text-center text-warning">{totalUnused}</td>
                                                        <td className="text-center">
                                                            <Badge bg={totalAllocated > 0 && (totalUsed / totalAllocated * 100) >= 50 ? 'success' : 'secondary'}>
                                                                {totalAllocated > 0 ? ((totalUsed / totalAllocated) * 100).toFixed(2) : '0.00'}%
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-center py-5">
                                        <i className="bi bi-inbox fs-1 text-muted"></i>
                                        <h5 className="mt-3 text-muted">No data available</h5>
                                        <p className="text-muted">Please select outlet and date to generate report</p>
                                    </div>
                                )}
                            </>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default JourneyCouponReport;